import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

import type { NodeLink } from '../../models/Nodes/NodeLink'
import type { ButtonProps } from '../BottomActions'
import type { ViewState } from '../Root/viewModel'

export type Props = {
  state: ViewState
}

export type ViewModel = {
  options: Array<NodeLink>
  buttons: Array<ButtonProps>

  handleClick: (number) => () => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    get options() {
      return state.currentNode.options
    },
    get buttons() {
      return vm.options.map((option) => ({
        highlighted: option.highlighted,
        handleClick: vm.handleClick(option.id),
        text: option.text,
        subtext: option.subtext,
      }))
    },
    handleClick: mobx.action((id) => () => {
      const option = vm.options.find((op) => op.id === id)
      if (!option) return
      if (option.externalLink) transitioner.openExternal(option.externalLink)
      if (option.link) transitioner.goForward(option.link.id)
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
